(function($) {

  var WW = $(window).width()
  var WH = $(window).height();

  function videoArticle() {
    var $videoWrapper = $('.single-post .entry-content')

    if (WW <= 832) $videoWrapper.fitVids()

    $(window).resize(function() {
      WW = $(window).width()
      if (WW <= 832) $videoWrapper.fitVids()
    })
  }

  // Functions
  function setupSlideshow(el) {
    var $el = $(el);
		var opts = {
      autoplay: true,
      dots: true,
      arrows: true,
      infinite: true,
      fade: true,
      autoplaySpeed: 10000,
    };

		$el.slick(opts);
  }

  function tilesMinHeight() {
    $el = $('.mh-auto');

  }

  var TilesMinHeight = function(el) {
    this.el = el
  }

  TilesMinHeight.prototype.init = function() {
    $el = $(this.el)

    $el.each(function( key, value ) {
      $container = $(value);
      $tiles = $container.find('.mh-content');
      $th = 0;
      $tiles.each(function( key, value ) {
        $tile = $(value);
        if ($th < $tile.height()) {

          $th = $tile.height()
        }
      });
      $container.find('.mh-content').css('min-height', $th);
      $container.find('.button').css('position', 'absolute');
    });
  }

  TilesMinHeight.prototype.reset = function() {
    $el = $(this.el)

    $el.each(function( key, value ) {
      $container = $(value);
      $container.find('.mh-content').css('min-height', 'initial');
      $container.find('.button').css('position', 'relative');
    });
  };


  function initTilesMinHeight() {
    var tmh = new TilesMinHeight('.mh-auto')

    if (WW >= 832) tmh.init()

    $(window).resize(function() {
      WW = $(window).width()

      if (WW >= 832) {
        //console.log('true', WW)
        tmh.init()
      } else {
        //console.log('false', WW)
        tmh.reset()
      }
    })
  }


  function slideshowHeight() {
    var $slideshow = $('#full-width-slideshow');
    var $slides = $('#full-width-slideshow article');
    var $image = $('#full-width-slideshow article img');
    var images_width = 0;
    var media_query = 520;

    $slides.css('height', WH);

    $(window).resize(function() {
      WH = $(window).height()
      $slides.css('height', WH);
    });


    //$image.each(function(i){
    //  images_width = $(this).width();
    //  var margin_left = images_width/2 - window_width/2,
    //      styles = {
    //        'margin-left': - margin_left,
    //        'height': "100%",
    //        'width': 'auto',
    //        'max-width': 'none',
    //        'min-width'
    //      };
    //  $(this).css(styles)
    //});
  }




  function initMasonry(el) {
    var opts = {
      itemSelector: '.masonry-grid-element',
      transitionDuration: '0.2s',

    }

    $(el).masonry(opts);
  }

  function initIsotope(filter, wrapper) {
    var $filter = $(filter);
    var $wrapper = $(wrapper);

    // init
    $wrapper.isotope({
      filters: '*'
    });

    $filter.on( 'click', 'li', function() {
      var value = $(this).hasClass('all') ? $(this).attr('data-filter') : '.' + $(this).attr('data-filter');
      //console.log('current-filter:', value)
      $wrapper.isotope({ filter: value });
    });
  }

  function scrollDownCTA() {
    var $cta = $('#full-width-slideshow .scroll-down-arrow')
    var $elementToScroll = $('#full-width-slideshow').next()
    var manualOffset = 0
    var elementOffset = ''

    $cta.on('click', function(e) {
      e.preventDefault()
      elementOffset = Math.ceil($elementToScroll.offset().top) - manualOffset

      $('body').animate({
        scrollTop: elementOffset
      }, 700)
    })
  }

  function scrollUp(el) {
    var $el = $(el)

    $(document).on("scroll", function() {
      if ($(document).scrollTop() > 600) {
        $el.addClass("unhide");
      } else {
        $el.removeClass("unhide");
      }
    });

    $el.click(function() {
      $('html, body').animate({
        scrollTop: 0
      }, 400);
      return false;
    });
  }


  function usersDescription() {
    var $user_more = $('.people .team-member .team-member__more')
    var $users_description = $('.people .team-member .team-member__description')
    $users_description.hide()

    $user_more.on('click', function(e) {
      e.preventDefault()
      if(!$(this).parents('.team-member__header').next('.team-member__description').hasClass('open')) {
        $('.team-member__description.open').removeClass('open').slideUp(200).parents('.team-member').removeClass('active')
        $(this).parents('.team-member__header').next('.team-member__description').addClass('open').show()
        $(this).parents('.team-member').addClass('active').removeClass('not-active')
        $('.team-member:not(.active)').addClass('not-active')
      } else {
        $('.team-member').removeClass('not-active')
        $(this).parents('.team-member__header').next('.team-member__description').removeClass('open').hide()
        $(this).parents('.team-member').removeClass('active')
      }
    })
  }

  function setupGallery() {
    var $gallery_wrapper = $('#full-width-gallery > .gallery')

    var opts = {
      centerMode: true,
      centerPadding: '200px',
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 831,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '100px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 520,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 1
          }
        }
      ]
    }

		$gallery_wrapper.slick(opts);
  }

  var incode_starter = {

    'common': {
      init: function() {
        setupSlideshow('#full-width-slideshow .slides')
        slideshowHeight()
        initTilesMinHeight()
        scrollDownCTA()
        initMasonry('.masonry-grid')
        initIsotope('.news-filter', '.news-wrapper')
        scrollUp('#scrollup')
        usersDescription()
        videoArticle()
        setupGallery()
      },
      finalize: function() {
      }
    },

    'home': {
      init: function() {
      },
      finalize: function() {

      }
    },

    'about_us': {
      init: function() {

      }
    }
  };

  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = incode_starter;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      UTIL.fire('common', 'finalize');
    }
  };

  $(document).ready(UTIL.loadEvents);

})(jQuery);
